var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detailcontainer"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.conText)}}),_vm._v(" "),_c('div',{staticClass:"clearfloat"})]),_vm._v(" "),_c('footBar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ca5b14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bannerdetail.vue
// module id = null
// module chunks = 